module.exports = global["PIXI"] = require("-!F:\\Projects\\PressPausePlay\\EDF Power Patrol\\node_modules\\uglify-loader\\index.js!.\\pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser/dist/pixi.js-exposed
// module id = 16
// module chunks = 0